import { DashboardModule, Form } from '@domain-group/suit-theme'

import PortalDataInput from '../PortalDataInput'

const PropertyAddress = () => (
  <DashboardModule boxProps={{ flexDirection: 'column', marginBottom: 'large' }} title="Property Address">
    <Form padding="large">
      <Form.Row>
        <Form.Row>
          <PortalDataInput fieldKey="subNumber" />

          <PortalDataInput marginTop={['large', 0]} fieldKey="streetNumber" />
        </Form.Row>

        <PortalDataInput marginTop={['large', 0]} fieldKey="street" />
      </Form.Row>

      <Form.Row>
        <Form.Row>
          <PortalDataInput marginTop="large" fieldKey="postcode" />

          <PortalDataInput marginTop="large" fieldKey="state" />
        </Form.Row>
        <PortalDataInput marginTop="large" fieldKey="suburb" />
      </Form.Row>

      <Form.Row>
        <PortalDataInput marginTop="large" fieldKey="hideAddress" />
      </Form.Row>
    </Form>
  </DashboardModule>
)

export default PropertyAddress
